import React from 'react';
import { ReconnectionBanner } from './ReconnectionBanner';
const meta = {
    title: 'Features/AIChatWidget/ReconnectionBanner',
    component: ReconnectionBanner,
    parameters: {
        layout: 'padded'
    },
    decorators: [
        (Story) => (React.createElement("div", { style: { maxWidth: 600, padding: 16, background: '#fff', borderRadius: 8 } },
            React.createElement(Story, null)))
    ]
};
export default meta;
export const Reconnecting = {
    args: {
        connectionState: 'reconnecting',
        reconnectAttempts: 2
    }
};
export const ReconnectingHighAttempts = {
    args: {
        connectionState: 'reconnecting',
        reconnectAttempts: 5
    }
};
export const ConnectionError = {
    args: {
        connectionState: 'error',
        reconnectAttempts: 6
    }
};
export const Connected = {
    args: {
        connectionState: 'connected',
        reconnectAttempts: 0
    },
    parameters: {
        docs: {
            description: {
                story: 'When connected, the banner renders nothing (returns null).'
            }
        }
    }
};
export const Connecting = {
    args: {
        connectionState: 'connecting',
        reconnectAttempts: 0
    },
    parameters: {
        docs: {
            description: {
                story: 'When initially connecting, the banner renders nothing (returns null).'
            }
        }
    }
};
